import {
  BANNER_BYID_LIST,
  BANNER_LIST,
  BANNER_LIST_LOADER,
  PROMOTIONAL_BANNER_LIST,
  PROMOTIONAL_BANNER_LIST_LOADER,
} from "../actions/type";

const initialState = {
  bannerList: {},
  bannerListLoader: false,
  bannerListById: {},
  promotionalBannerList: {},
  promotionalBannerListLoader: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case BANNER_LIST:
      return {
        ...state,
        bannerList: payload,
        bannerListLoader: false,
      };

    case BANNER_LIST_LOADER:
      return {
        ...state,
        bannerListLoader: payload,
      };

    case PROMOTIONAL_BANNER_LIST:
      return {
        ...state,
        promotionalBannerList: payload,
        promotionalBannerListLoader: false,
      };

    case PROMOTIONAL_BANNER_LIST_LOADER:
      return {
        ...state,
        promotionalBannerListLoader: payload,
      };

    case BANNER_BYID_LIST:
      return {
        ...state,
        bannerListById: payload,
      };

    default:
      return state;
  }
}
